
<div class="wrapper">
  <section id="verificacao">
    <div class="container area-faca-parte">
      <form class="sample-form" method="post" target="_top">
        <div class="body-faca-parte columns">
          <div class="column is-full">
            
            <div class="dados-pessoais text-center">

              <h3>Muito Obrigado pela confirmação, Pedro!</h3>
              <p>
                Como esse é o seu Primeiro Acesso, vou precisar que você Renove Sua Senha para sua própria segurança.
              </p>
              <div class="field forms-dados" tabindex="1">
                <label class="senha" name="senha">Senha</label>
                <input name="senha" type="senha" placeholder="E-mail" required>
              </div>

              <div class="field forms-dados" tabindex="1">
                <label class="confirme-senha" name="senha">Confirme sua senha</label>
                <input name="confirme-senha" type="password" placeholder="Confirme sua senha" required>
              </div>

              <button type="submit" class="btn-verde">RENOVAR MINHA SENHA</button>

            </div>
          </div>

        </div>

        
      </form>
    </div>
  </section>

</div>


